module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-thinking.c6f3f616.png";